import { validatePythonVariable } from '@polyai/common/lib/stringHelper';
import type { Flow } from '@polyai/stream/store/reducers/flows';
import type { Function } from '@polyai/stream/store/reducers/functions';

import type { MinimalFlow } from 'api/resources/flows/types';
import type { FunctionCall } from 'api/types';

// TODO: delete after migration
export const validateFunctionName =
  (existingValues: FunctionCall[] = [], current?: FunctionCall) =>
  (name: string) => {
    const error = validatePythonVariable(name);
    if (error !== true) {
      return error;
    }

    // case transition func -> filter all transition not equal to current (allow globals)
    if (current?.flow_id) {
      // filters globals (i.e. no flow_id) and same flow_id
      existingValues = existingValues.filter(
        f => f.flow_id == null || f.flow_id === current.flow_id,
      );
    }

    const isNameInUse = existingValues.some(
      v => v.name === name && v.function_id !== current?.function_id,
    );

    return isNameInUse ? `${name} is already in use` : true;
  };

// TODO: Delete after migration
export const validateMinimalFlowName =
  (existingValues: MinimalFlow[] = []) =>
  (name: string) => {
    const isNameInUse = existingValues.some(v => v.name === name);

    return isNameInUse ? `${name} is already in use` : true;
  };

export const validateStreamFunctionName =
  (existingValues: Function[] = [], current?: Omit<Function, 'references'>) =>
  (name: string) => {
    const error = validatePythonVariable(name);
    if (error !== true) {
      return error;
    }

    const isNameInUse = existingValues.some(
      v => v.name === name && v.id !== current?.id,
    );

    return isNameInUse ? `${name} is already in use` : true;
  };

export const validateFlowName =
  (existingValues: Flow[] = []) =>
  (name: string) => {
    const isNameInUse = existingValues.some(v => v.name === name);

    return isNameInUse ? `${name} is already in use` : true;
  };
